import { render, staticRenderFns } from "./s-home.vue?vue&type=template&id=0176c37c&"
import script from "./s-home.vue?vue&type=script&lang=js&"
export * from "./s-home.vue?vue&type=script&lang=js&"
import style0 from "./s-home.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports